import { render, staticRenderFns } from "./NewSpeaker.vue?vue&type=template&id=c6730a00&"
import script from "./NewSpeaker.vue?vue&type=script&lang=js&"
export * from "./NewSpeaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports